import { ALI_ADMIN } from '@rsos/constants/locationApplications';

// Item is a type representing an emergency call or location object. For now, we only care
// about the isAdmin and application properties which could be on either object type. Future
// ignore criteria may require additional properties.
type Item =
  | {
      isAdmin?: boolean;
      application?: string;
      [key: string]: any;
    }
  | null
  | undefined;

// Type for the functions that identify if an item should be ignored.
type IdentifierFunction = (item: Item) => boolean;

// Ignore type identifier function(s)
const isAdmin: IdentifierFunction = item =>
  !!(item?.isAdmin || item?.application === ALI_ADMIN);

// A map of call types that should be fully ignored by the map to their respective identifier functions
// typeName : identifierFunction
const IGNORED_TYPE_TO_IDENTIFIER_FUNCTIONS: Record<string, IdentifierFunction> =
  {
    adminType: isAdmin,
  };

/**
 * Tests the call against the identifier functions that identify calls that should be ignored by the map.
 * @param {Item} item - Object representing the emergency call or location object.
 * @returns {boolean} - True if the item should be ignored, false otherwise.
 */
export const isIgnoreType = (item: Item): boolean => {
  return Object.values(IGNORED_TYPE_TO_IDENTIFIER_FUNCTIONS).some(
    identifierFunction => identifierFunction(item),
  );
};
